export const FASTAPI_ENDPOINT = "/api";
